// extracted by mini-css-extract-plugin
module.exports = {"follow":"e_EQ","button":"e_FQ","note":"e_GQ","error":"e_HQ"};